import axios from 'axios';
import Framework from '@greenville/framework';
import utils from '../../../common/utils';
import env from '../../../common/env';
import * as constants from '../../../common/constants';

const getExecutionLogs = async (requestId, tenantId) => {
  const token = utils.getToken();
  try {
    const response = await axios.get(`${env.AI_ADMIN_SERVICES}/api/v1/logs/${requestId}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        [constants.BERLIN_TENANT_ID_HEADER]: tenantId
      }
    });

    const { data } = response;
    if (data.success) {
      return data;
    }
    const notification = {
      open: true,
      type: 'error',
      message: `Error fetching execution logs`
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
    return null;
  } catch (err) {
    return err;
  }
};

export default getExecutionLogs;
